import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=2065fc30&scoped=true&"
import script from "./SubmitButton.vue?vue&type=script&lang=js&"
export * from "./SubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=2065fc30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065fc30",
  null
  
)

export default component.exports